"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getClientSideDomainContextProps = exports.getServerSideDomainContextProps = exports.appWithDomain = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _useRouteChange = _interopRequireDefault(require("./hooks/useRouteChange"));

// typescript import
// import
// definition
var DomainContext = /*#__PURE__*/_react["default"].createContext({
  domain: null,
  serverRouter: null,
  previousUrl: '/'
});

DomainContext.displayName = "LinkDomainDomainContext"

var appWithDomain = function appWithDomain(App) {
  var Component = function Component(_ref) {
    var domain = _ref.domain,
        serverRouter = _ref.serverRouter,
        props = (0, _objectWithoutProperties2["default"])(_ref, ["domain", "serverRouter"]);
    var previousUrl = (0, _useRouteChange["default"])();
    return /*#__PURE__*/_react["default"].createElement(DomainContext.Provider, {
      value: {
        previousUrl: previousUrl,
        domain: domain,
        serverRouter: serverRouter
      }
    }, /*#__PURE__*/_react["default"].createElement(App, props));
  };

  Component.getInitialProps = App.getInitialProps;
  return Component;
};

exports.appWithDomain = appWithDomain;

var getServerSideDomainContextProps = function getServerSideDomainContextProps(ctx, router) {
  var _ctx$req;

  return {
    domain: ((_ctx$req = ctx.req) === null || _ctx$req === void 0 ? void 0 : _ctx$req.headers.host) || null,
    serverRouter: router
  };
};

exports.getServerSideDomainContextProps = getServerSideDomainContextProps;

var getClientSideDomainContextProps = function getClientSideDomainContextProps() {
  return {
    domain: window.location.host,
    serverRouter: null
  };
};

exports.getClientSideDomainContextProps = getClientSideDomainContextProps;
var _default = DomainContext;
exports["default"] = _default;